// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3RsQy","title":"ClientReferral_title__NIMud","itemText":"ClientReferral_itemText__M-8pt"};